import { Observable } from 'rxjs';
import { EventSource } from './eventSource';
import { EventUser } from './eventUser';

import 'rxjs/add/observable/interval'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/switchMap'

export interface CalendarEvent {
    detail?: string;
    dtstart: number;
    dtend: number;
    hideTime: boolean;
    key: string;
    location: string;
    name: string;
    noEndTime: boolean;
    tzid: string;
    place_id?: string;
    showMap?: boolean;
    isMain?: boolean;
}

export interface EventCountdown {
    millisecondsToEvent: number;
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

import { Photo } from './interfaces';

export class EventSchedule {

    private es: EventSource;

    constructor(eventSource: EventSource) {
        this.es = eventSource;
    }

    public observeSchedule() {
        return Observable.combineLatest(
            this.observeCalendar(),
            this.observeScheduleMapUrl(),
            this.observePrimarySchedulePhoto(),
            this.observeHasPrivateEvents(),
            (calendar, mapUrl, primaryPhoto, hasPrivateEvents) => {
                return {
                    calendar,
                    mapUrl,
                    primaryPhoto,
                    hasPrivateEvents
                }
            }
        )
    }

    public observeScheduleMapUrl(): Observable<string> {
        return this.es.pluckData(this.es.observeSchedulePage(), ['mapUrl']);
    }

    public observeHasPrivateEvents(): Observable<boolean> {
      const api = this.es.getDatasource().getEvent().getBestServiceApi();
      return Observable.fromPromise(
        api.queryGraphQLWithErrors(`
          query {
            event(eventId:"${this.es.getDatasource().getEvent().getEventId()}") {
              info {
                schedule {
                  hasPrivateEvents
                }
              }
            }
          }
        `)
          .then(data => data.event.info.schedule.hasPrivateEvents)
      );
    }

    public observeCalendar(): Observable<Array<CalendarEvent>> {
      const calendarUpdates = this.es.pluckData(this.es.observeSchedulePage(), ['calendar']);
      const eventUser = (new EventUser(this.es)).observeUser();

      return Observable.combineLatest(eventUser, calendarUpdates, eventUser => eventUser)
        .flatMap(() => {
        const api = this.es.getDatasource().getEvent().getBestServiceApi();
        return Observable.fromPromise(
          api.queryGraphQLWithErrors(`
            query {
              event(eventId:"${this.es.getDatasource().getEvent().getEventId()}") {
                info {
                  schedule {
                    calendar {
                      key
                      details
                      dtstart
                      dtend
                      hideTime
                      location
                      name
                      noEndTime
                      tzid
                      placeId
                      place_id
                      showMap
                      isMain
                      dressCode
                      unplug
                      tel
                      virtualEventLink {
                        provider
                        linkText
                        urlLinkText
                        urlBrowser
                      }
                    }
                  }
                }
              }
            }
          `)
            .then(data => data.event.info.schedule.calendar)
        );
      })
      .map((data: Array<CalendarEvent>) => data.sort((a, b) => a.dtstart - b.dtstart));
    }

    public observeMainEvent(): Observable<CalendarEvent> {
        return this.observeCalendar().map(events => events.map(event => (event.isMain) ? event : null).filter(x => x)[0]);
    }

    public observePrimarySchedulePhoto(): Observable<Photo> {
        return this.es.observePrimaryPhoto(this.es.observeSchedulePage());
    }

    public observePrimarySchedulePhotoHorizontal(): Observable<Photo> {
        return this.es.observePrimaryPhotoHorizontal(this.es.observeSchedulePage());
    }

}
